import { Container } from "./grid-item.styles"

export default Container
